type Props = {
  title1: string;
  title2: string;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick1?: (e: React.MouseEvent) => void;
  onClick2?: (e: React.MouseEvent) => void;
};

export default function ButtonDuo({ title1, title2, type, onClick1, onClick2 }: Props): JSX.Element {
  return (
    <div className="N_14_M flex">
      <button
        type={type ? type : 'button'}
        className="h-12 w-2/4 bg-white border-l border-t border-b border-very-light-grey rounded-l-sm text-black flex justify-center items-center focus:text-opacity-50"
        onClick={(e) => onClick1 && onClick1(e)}
      >
        {title1}
      </button>
      <button
        type={type ? type : 'button'}
        className="h-12 w-2/4 bg-bluey-purple rounded-r-sm text-white flex justify-center items-center focus:bg-active-bluey-purple"
        onClick={(e) => onClick2 && onClick2(e)}
      >
        {title2}
      </button>
    </div>
  );
}
